export default function formatDate(
    date,
    options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    },
    region = 'en-GB'
) {
    if (!date) {
        return '-'
    }
    if (!(date instanceof Date)) {
        date = new Date(date)
    }

    return new Intl.DateTimeFormat(region, options).format(date)
}
